import Advice from '@/components/bussiness/advice/advice.vue';
import equipment from '@/components/bussiness/checkEquipment/equipment.vue';
import Class from '@/components/bussiness/class/class';
import coinexplain from '@/components/bussiness/class/coinexplain.vue';
import coinrecord from '@/components/bussiness/class/coinrecord.vue';
import MyselfBadge from '@/components/bussiness/class/myselfBadge';
import Course from '@/components/bussiness/course/course';
import Cancell from '@/components/bussiness/explain/cancell.vue';
import ChildrenPolicy from '@/components/bussiness/explain/childrenPolicy.vue';
import Explain from '@/components/bussiness/explain/explain.vue';
import ForRecord from '@/components/bussiness/explain/forrecord.vue';
import GameMenu from '@/components/bussiness/game/gameMenu.vue';
import PlayGame from '@/components/bussiness/game/playgame.vue';
import HomePage from '@/components/bussiness/homepage/homepage';
import homework from '@/components/bussiness/homework/index.vue';
import Login from '@/components/bussiness/login/login.vue';
import MessageDetail from '@/components/bussiness/message/messageDetail';
import MessageList from '@/components/bussiness/message/messageList';
import Password from '@/components/bussiness/password/password';
import passwordreset from '@/components/bussiness/passwordreset/passwordreset.vue';
import Playback from '@/components/bussiness/playback/playback.vue';
import Reset from '@/components/bussiness/reset/index.vue';
import Update from '@/components/bussiness/updatecheck/updatecheck.vue';
import ChangePhoto from '@/components/bussiness/userInfo/changePhoto.vue';
import UserInfo from '@/components/bussiness/userInfo/userInfo.vue';
import Video from '@/components/bussiness/video/video';
import Vue from 'vue';
import Router from 'vue-router';
Vue.use(Router);

export default new Router({
  routes: [
    {
      path: '/',
      // name: "login",
      // component: Login
      name: 'homepage',
      component: HomePage,
    },
    {
      path: '/login',
      name: 'login',
      component: Login,
    },
    // {
    //   path: '/reset',
    //   name: 'login',
    //   component: Login,
    // },
    {
      path: '/reset',
      name: 'reset',
      component: Reset,
    },
    {
      path: '/class',
      name: 'class',
      component: Class,
    },
    {
      path: '/course',
      name: 'course',
      component: Course,
    },
    {
      path: '/password',
      name: 'password',
      component: Password,
    },
    {
      path: '/video',
      name: 'video',
      component: Video,
    },
    {
      path: '/userInfo', //个人中心
      name: 'userInfo',
      component: UserInfo,
    },
    {
      path: '/changePhoto', //头像页面
      name: 'changePhoto',
      component: ChangePhoto,
    },
    {
      path: '/homework', //鼓励
      name: 'homework',
      component: homework,
    },
    {
      path: '/playback', //回放页面
      name: 'playback',
      component: Playback,
    },
    {
      path: '/myselfBadge', //个人徽章
      name: 'myselfBadge',
      component: MyselfBadge,
    },
    {
      path: '/gameMenu', //游戏菜单
      name: 'gameMenu',
      component: GameMenu,
    },
    {
      path: '/playgame', //玩游戏页面
      name: 'playGame',
      component: PlayGame,
    },
    {
      path: '/coinrecord', //金币记录
      name: 'coinrecord',
      component: coinrecord,
    },
    {
      path: '/coinexplain', //金币说明
      name: 'coinexplain',
      component: coinexplain,
    },
    {
      path: '/advice', //意见建议
      name: 'advice',
      component: Advice,
    },
    {
      path: '/explain', //隐私协议和联系我们
      name: 'explain',
      component: Explain,
    },
    {
      path: '/childrenPolicy', //儿童隐私保护政策
      name: 'ChildrenPolicy',
      component: ChildrenPolicy,
    },
    {
      path: '/cancell', //注销账号
      name: 'cancell',
      component: Cancell,
    },
    {
      path: '/forrecord', //备案公示
      name: 'ForRecord',
      component: ForRecord,
    },
    {
      path: '/update', //版本更新
      name: 'update',
      component: Update,
    },
    {
      path: '/msg', //消息列表
      name: 'msg',
      component: MessageList,
    },
    {
      path: '/msgdetail', //消息列表
      name: 'msgdetail',
      component: MessageDetail,
    },
    {
      path: '/equipment', //设备检测
      name: 'equipment',
      component: equipment,
    },
    {
      path: '/passwordreset', //重置密码
      name: 'passwordreset',
      component: passwordreset,
    },
  ],
});



// WEBPACK FOOTER //
// ./src/router/index.js